/**
 * Stable per-browser device identifier for this portal, analogous to the
 * field mobile app's own device binding — m46-parking's notice-number block
 * allocation (POST /officers/:id/notice-blocks) and contravention issuance
 * (POST /contraventions) both take a `deviceId`. Generated once with the Web
 * Crypto API (this is a networked desktop app; no need for the mobile app's
 * hand-rolled non-crypto UUID workaround for offline environments) and
 * cached so reloading the page doesn't churn through a fresh device
 * identity — and therefore a fresh notice-number block — every time.
 */
const KEY = 'parking-portal.deviceId';

export function getDeviceId(): string {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
}
